import { useEffect, useRef, useState } from 'react';

const useIntersect = (
  props: IntersectionObserverInit,
): [
  (
    value:
      | ((prevState: HTMLElement | null) => HTMLElement | null)
      | HTMLElement,
  ) => void,
  IntersectionObserverEntry | undefined,
] => {
  const { root = undefined, rootMargin = '', threshold = [] } = props;
  const [entryItems, updateEntry] = useState<IntersectionObserverEntry>();
  const [node, setNode] = useState<HTMLElement | null>(null);

  const observer = useRef(
    typeof window !== 'undefined'
      ? new window.IntersectionObserver(([entry]) => updateEntry(entry), {
          root,
          rootMargin,
          threshold,
        })
      : null,
  );

  useEffect(() => {
    const { current: currentObserver } = observer;
    currentObserver?.disconnect();

    if (node) currentObserver?.observe(node);

    return () => currentObserver?.disconnect();
  }, [node]);
  return [setNode, entryItems];
};

export default useIntersect;
